import { compose } from '../functional/compose';
import { toLowerCaseWithoutDiacritics } from './to-lower-case-without-diacritics';
import { toString } from './to-string';
/**
 * @name valueToComparableString
 * @description This function transform a value into a string. It removes the diactrics and the capitals letters
 * @param {Primitive} value The value to transform
 * @returns {string} The transformed value
 *
 * @example
 * // String
 * const myString = 'élEpHant';
 * const transformed = valueToComparableString(myString);
 * console.log(transformed); // elephant
 *
 * @example
 * // Number
 * const myValue = 15;
 * const transformed = valueToComparableString(myValue);
 * console.log(transformed); // '15'
 *
 */
const valueToComparableString = compose(toLowerCaseWithoutDiacritics, toString);
export { valueToComparableString };
//# sourceMappingURL=value-to-comparable-string.js.map